





















import { Component, Vue, Watch, Mixins, Prop } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import CheckboxSquare from '@/components/atoms/CheckboxSquare.vue'
import RadioToggle from '@/components/atoms/RadioToggle.vue'
import QueryMethods from '../atoms/QueryMethods.vue'
import StudentIdsInfo from '@/views/teacher/v3/StudentIdsInfo.vue'
import { CourseResponse } from './v3/ModalStudentCourses.vue'

export const SUBJECTS = {
  ei: { id: '2', name: '英語' },
  ko: { id: '3', name: '国語' },
  su: { id: '1', name: '算数/数学' },
  ri: { id: '4', name: '理科' },
  sh: { id: '5', name: '社会' },
} as const

@Component({
  components: {
    ButtonBase,
    CheckboxSquare,
    RadioToggle,
  },
})
export default class SelectCoursesStandardTable extends Mixins(QueryMethods, StudentIdsInfo) {
  @Prop()
  courseDefault?: CourseResponse

  @Watch('standardCourseSelected', { deep: true })
  private onCourseSelectedChange(): void {
    this.$emit('onCourseStandardChange', this.standardCourseSelected)
  }

  @Watch('courseDefault', { deep: true })
  private onHandleDefaultStandardData(): void {
    this.handleDefaultStandardData()
  }

  private logDefault() {
    console.log(this.courseDefault)
  }

  private small = true

  private striped = false

  private bordered = true

  private subjects = SUBJECTS

  private standardCourseSelected = {}

  private branchGdlsServices = {}

  private async mounted() {
    await this.loadBranchServices()
    const studentInfo = this.$store.state.studentCreationInfo.studentInfo
    if (studentInfo.standardCourses) {
      this.standardCourseSelected = studentInfo.standardCourses
    } else {
      this.handleDefaultStandardData()
    }
  }

  private handleDefaultStandardData() {
    const activeSubjects = this.courseDefault ? this.courseDefault.courseData.map((subject) => subject.subjectId) : []
    this.standardCourseSelected = Object.values(SUBJECTS).reduce((acc: { [subjectId: string]: boolean }, subject) => {
      acc[subject.id] = activeSubjects.includes(Number(subject.id))
      return acc
    }, {})
  }

  private async loadBranchServices() {
    await Vue.prototype.$http.httpWithToken
      .get(`/v3/branches/services`, { params: { branchId: this.branchId, academyId: this.academyId } })
      .then((res: any) => {
        const gdlsServiceCode = 'gdls'
        const gdlsService = res.data.branches[0].services.find(
          (service: { code: string }) => service.code === gdlsServiceCode
        )
        this.branchGdlsServices = gdlsService.subjects.reduce(
          (subjects: { [id: string]: boolean }, subject: { subjectId: number; isEnabled: boolean }) => {
            subjects[subject.subjectId] = subject.isEnabled
            return subjects
          },
          {}
        )
      })
  }

  private tableFields: object[] = [{ key: 'subject', label: '教科' }]
}
